import React from 'react'

function Contact(props) {
	return (
		<div>
			<h1>Contact</h1>
			<p>Work in progress</p>
		</div>
	)
}

export default Contact
